import LoginComponent from '../components/Login';
import ForbiddenComponent from '../components/Exceptions/403';
import NoFoundComponent from '../components/Exceptions/404';
import ErrorComponent from '../components/Exceptions/500';
import FormComponent from '../components/Form';
import TableComponent from '../components/Table';
import MenusManageComponent from '../components/MenusManage';
import RolesManageComponent from '../components/RolesManage';
import UsersManageComponent from '../components/UsersManage';
import SystemConfigManageComponent from '../components/SystemConfigManage';
import AboutUsComponent from '../components/AboutUs';
import NewsViewComponent from '../components/NewsView';
import LogViewComponent from '../components/LogView';
import BillboardComponent from '../components/Billboard';
import DownloadComponent from '../components/FileDownload';
import ContactUsComponent from '../components/ContactUs';
import SignInComponent from '../components/SignIn';
import PWComponent from '../components/PasswordView';
import EnglishFormComponent from '../components/EnglishForm';
import EnglishTableComponent from '../components/EnglishTable';
import DepenglishFormComponent from '../components/DepenglishForm';
import StuenglishTableComponent from '../components/StuenglishTable';
import GermanFormComponent from '../components/GermanForm';
import GermanTableComponent from '../components/GermanTable';
import DepgermanFormComponent from '../components/DepgermanForm';
import StugermanTableComponent from '../components/StugermanTable';
import JapaneseFormComponent from '../components/JapaneseForm';
import JapaneseTableComponent from '../components/JapaneseTable';
import DepjapaneseFormComponent from '../components/DepjapaneseForm';
import StujapaneseTableComponent from '../components/StujapaneseTable';
import ChineseFormComponent from '../components/ChineseForm';
import ChineseTableComponent from '../components/ChineseTable';
import DepchineseFormComponent from '../components/DepchineseForm';
import StuchineseTableComponent from '../components/StuchineseTable';
import LoginSSOView from '../components/LoginSSOView'

const routeDefs = [
    {name: 'root', path: '/'},
    // {menuId:01    , component:, title:'報表範例'},
    {name: '0101', component: FormComponent, path: '/Form', meta: {requiresAuth: true}, exact: true},
    //{name: '0102', title:'表格範例'},
    { name: '010201', component: TableComponent, path: '/Table', meta: { requiresAuth: true }, exact: true },
    { name: '030101', component: EnglishFormComponent, path: '/EnglishForm', meta: { requiresAuth: true }, exact: true },
    { name: '030102', component: StuenglishTableComponent, path: '/StuenglishTable', meta: { requiresAuth: true }, exact: true },
    { name: '030103', component: DepenglishFormComponent, path: '/DepenglishForm', meta: { requiresAuth: true }, exact: true },
    { name: '030104', component: EnglishTableComponent, path: '/EnglishTable', meta: { requiresAuth: true }, exact: true },
    { name: '040101', component: JapaneseFormComponent, path: '/JapaneseForm', meta: { requiresAuth: true }, exact: true },
    { name: '040102', component: StujapaneseTableComponent, path: '/StujapaneseTable', meta: { requiresAuth: true }, exact: true },
    { name: '040103', component: DepjapaneseFormComponent, path: '/DepjapaneseForm', meta: { requiresAuth: true }, exact: true },
    { name: '040104', component: JapaneseTableComponent, path: '/JapaneseTable', meta: { requiresAuth: true }, exact: true },
    { name: '050101', component: GermanFormComponent, path: '/GermanForm', meta: { requiresAuth: true }, exact: true },
    { name: '050102', component: StugermanTableComponent, path: '/StugermanTable', meta: { requiresAuth: true }, exact: true },
    { name: '050103', component: DepgermanFormComponent, path: '/DepgermanForm', meta: { requiresAuth: true }, exact: true },
    { name: '050104', component: GermanTableComponent, path: '/GermanTable', meta: { requiresAuth: true }, exact: true },
    { name: '070101', component: ChineseFormComponent, path: '/ChineseForm', meta: { requiresAuth: true }, exact: true },
    { name: '070102', component: StuchineseTableComponent, path: '/StuchineseTable', meta: { requiresAuth: true }, exact: true },
    { name: '070103', component: DepchineseFormComponent, path: '/DepchineseForm', meta: { requiresAuth: true }, exact: true },
    { name: '070104', component: ChineseTableComponent, path: '/ChineseTable', meta: { requiresAuth: true }, exact: true },
    // {name:'0301', path: '/Demo', component:Demo, meta:{requiresAuth: true}, exact:true},
    {name: '9701', component: BillboardComponent, path: '/Billboard', meta: {requiresAuth: false}, exact: true},
    {name: '9801', component: DownloadComponent, path: '/Download', meta: {requiresAuth: false}, exact: true},
    {name: '990106', component: NewsViewComponent, path: '/News', meta: {requiresAuth: true}, exact: true},
    {name: '990107', component: LogViewComponent, path: '/Log', meta: {requiresAuth: true}, exact: true},
    {name: '990105', component: PWComponent, path: '/PassW', meta: {requiresAuth: true}, exact: true},
    //{name: '9901', title:'權限'},
    {name: '990101', component: MenusManageComponent, path: '/MenusManage', meta: {requiresAuth: true}, exact: true},
    {name: '990102', component: RolesManageComponent, path: '/RolesManage', meta: {requiresAuth: true}, exact: true},
    {
        'name': '990103',
        'component': UsersManageComponent,
        'path': '/UserManage',
        'meta': {'requiresAuth': true},
        'exact': true
    },
    {
        'name': '990104',
        'component': SystemConfigManageComponent,
        'path': '/config',
        'meta': {'requiresAuth': true},
        'exact': true
    },
    {
        name: 'aboutUs',
        path: '/aboutUs',
        component: AboutUsComponent,
        exact: true,
    },
    {
        name: 'contactUs',
        path: '/contactUs',
        component: ContactUsComponent,
        exact: true,
    },
    {
        path: '/login',
        component: LoginComponent,
        name: 'login'
    },
    {
        path: '/signIn',
        component: SignInComponent,
        name: 'signIn'
    },
    {
        path: '/loginsso',
        name: 'Loginsso',
        component: LoginSSOView
      },
    {
        path: '/403',
        component: ForbiddenComponent,
        name: 'forbidden'
    },
    {
        path: '/404',
        component: NoFoundComponent,
        name: 'noFound'
    },
    {
        path: '/500',
        component: ErrorComponent,
        name: 'error'
    },
    {
        path: '/sso',
        name: 'sso'
    },
    {
        path: '*',
        name: 'asterisk'
    }
];

export default routeDefs;